var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3979_25048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 20.9489C11.385 20.94 11.7545 20.7953 12.043 20.5403C12.3315 20.2853 12.5206 19.9365 12.5767 19.5555H9.3623C9.42004 19.9468 9.61795 20.3039 9.91921 20.5602C10.2205 20.8165 10.6046 20.9546 11.0001 20.9489Z",
    fill: "var(--klothed-textColor)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0749 17.1905L19.8671 17.0072C19.2776 16.482 18.7617 15.8797 18.3332 15.2167C17.8652 14.3016 17.5848 13.3022 17.5082 12.2772V9.25833C17.5057 8.89163 17.473 8.52576 17.4104 8.16444C16.3753 7.95167 15.4455 7.38773 14.7784 6.56808C14.1113 5.74844 13.748 4.72345 13.7499 3.66666V3.28166C13.1118 2.96767 12.4263 2.76118 11.721 2.67055V1.90055C11.721 1.68418 11.635 1.47667 11.482 1.32367C11.329 1.17067 11.1215 1.08472 10.9052 1.08472C10.6888 1.08472 10.4813 1.17067 10.3283 1.32367C10.1753 1.47667 10.0893 1.68418 10.0893 1.90055V2.70111C8.51004 2.92389 7.06468 3.7105 6.02007 4.91573C4.97547 6.12096 4.40216 7.66341 4.40599 9.25833V12.2772C4.32945 13.3022 4.04897 14.3016 3.58099 15.2167C3.15986 15.8781 2.65222 16.4803 2.07155 17.0072L1.86377 17.1905V18.9139H20.0749V17.1905Z",
    fill: "var(--klothed-textColor)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 6.7222C20.0209 6.7222 21.3889 5.35418 21.3889 3.66664C21.3889 1.9791 20.0209 0.611084 18.3334 0.611084C16.6459 0.611084 15.2778 1.9791 15.2778 3.66664C15.2778 5.35418 16.6459 6.7222 18.3334 6.7222Z",
    fill: "var(--klothed-textColor)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3979_25048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "var(--klothed-textColor)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.7eefea581b0070cdff5504781a2f27fd.svg";
export { ForwardRef as ReactComponent };